import { VacancyAd } from '../strapi/types';

export enum VacancyTypes {
  job = 'Job',
  traineeship = 'Traineeship',
  internship = 'Internship',
}
export type VacancyType = VacancyTypes.job | VacancyTypes.internship | VacancyTypes.traineeship;

export type JobSummary = {
  city: string[];
  company?: { logoURL: string; title: string };
  img?: string;
  photoURL?: string;
  objectID: string;
  title: string;
  type: string;
  employment: VacancyTypes;
  employmentType?: string[];
  description?: string;
  shortDescription?: string;
  slug: string;
  salaryRate?: string;
  salaryUnit?: string;
  salaryCurrency?: string;
  salaryMin?: number;
  salaryMax?: number;
};
export type Job = {
  company?: {
    logoURL: string;
    title: string;
    website?: string;
    phone?: string;
    address?: string;
    slug?: string;
    actionText?: string;
    companySize?: string;
    photoURL?: string;
    videoURL?: string;
    description?: string;
    shortDescription?: string;
    city?: string | string[];
    province?: string | string[];
  };
  shortDescription?: string;
  photoURL?: string;
  isVerified?: boolean;
  videoURL?: string;
  companySize?: string;
  companyName?: string;
  education: Array<string>;
  jobFunction?: Array<string>;
  languages: Array<string>;
  workExperience?: string;
  phone?: string;
  industry?: string[];
  website?: string;
  address: string;
  province?: string | string[];
  originalUrl?: string;
  deloitteId?: string;
  dateOfSubmission?: string;
  validThrough?: string;
  salaryRate?: string;
  byStudenten?: boolean;
  createdAt?: string;
} & JobSummary;

type VacancyAdCardJobFields =
  | 'slug'
  | 'title'
  | 'description'
  | 'shortDescription'
  | 'employmentType'
  | 'salaryCurrency'
  | 'salaryMin'
  | 'salaryMax'
  | 'salaryUnit'
  | 'city'
  | 'companyName';

type VacancyAdStrapiFields = 'vacancyUrl' | 'linkText' | 'openInNewWindow' | 'importantInfo';
export type VacancyAdCard = Pick<Job, VacancyAdCardJobFields> &
  Pick<VacancyAd, VacancyAdStrapiFields> & {
    isRecommended: boolean;
    imageUrl?: string;
    companyLogo?: string;
  };
